<template>
  <!--footer-->
  <section class="footer container">
    <hr />
    <p>© 2019 SDUT Software Laboratory Org.</p>
  </section>
</template>

<script>
export default {
  name: "foot",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue